import './SalesforceSetupPanel.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { createAsyncSelectors } from '@lib/selectors';
import dayjs from 'dayjs';
import { importsActions } from '@sonar-software/sonar-imports';
import { OrganizationMetadata } from '@sonar-software/sonar-core';
import { PlayCircleOutlined } from '@ant-design/icons';
import { useAction } from '@hooks';
import { Button, Checkbox, Popconfirm, Tag } from 'antd';
import React, { useCallback, useState } from 'react';

export const defaultShardCatalogDetailSelectors = createAsyncSelectors((state) => state.imports.salesforce.start.post);

export interface SalesforceOrganizationSyncControlsProps {
	organization?: OrganizationMetadata;
	shardName?: string;
}

export const SalesforceOrganizationSyncControls: React.FC<SalesforceOrganizationSyncControlsProps> = (props) => {
	const { organization, shardName } = props;

	const [ isSyncing, setIsSyncing ] = useState(organization?.salesforceSyncInProgress ?? false);
	const [ forceFullRefresh, setForceFullReset ] = useState(false);

	const handleForceFullResetChange = useCallback((e: CheckboxChangeEvent) => {
		setForceFullReset(e.target.checked);
	}, []);

	const startSync = useAction(importsActions.requestPostImportsSalesforceStart);

	const handleStartSync = useCallback(() => {
		if (organization) {
			setIsSyncing(true);
			startSync({
				forceFullRefresh: forceFullRefresh,
				organizationId: organization.id,
				shardName: shardName
			});
		}
	}, [ startSync, forceFullRefresh, organization, shardName ]);

	const syncTime = organization?.latestIndexTime ? dayjs.utc(organization?.latestIndexTime).local()
		.calendar() : '';

	return organization ?
		<div>
			<span className='last-sync-status'>
				<span className='last-sync-time'>{ syncTime }</span>
				<span className='last-sync-failed'>
					{ organization?.salesforceSyncFailed &&
						<Tag
							className='last-sync-failed-tag'
							color={ 'red' }>
							{ ADMIN_DASHBOARD_COPY.FAILED }
						</Tag> }
				</span>
			</span>
			{ isSyncing ?
				<Button
					className='start-sync-button'
					loading>
					{ ADMIN_DASHBOARD_COPY.SYNC_IN_PROGRESS }
				</Button>			 :
				<Popconfirm
					cancelText={ ADMIN_DASHBOARD_COPY.NO }
					className='start-sync-button'
					okText={ ADMIN_DASHBOARD_COPY.YES }
					onConfirm={ handleStartSync }
					title={ ADMIN_DASHBOARD_COPY.START_NEW_SYNC_CONFIRMATION }>
					<Button icon={ <PlayCircleOutlined /> }>{ ADMIN_DASHBOARD_COPY.START_NEW_SYNC }</Button>
				</Popconfirm> }
			<Checkbox
				checked={ forceFullRefresh }
				className='force-full-refresh-checkbox'
				disabled={ isSyncing }
				id='force-full-refresh-checkbox'
				onChange={ handleForceFullResetChange }>
				{ ADMIN_DASHBOARD_COPY.FORCE_FULL_REFRESH }
			</Checkbox>
		</div> :
	 null;
};
